/**
 * Created by razial on 21.09.2026.
 */

Mission.TYPE_SOFTFEAST = 22;

RewardTypes.mission.icon[Mission.TYPE_SOFTFEAST] = bundles.reward_icons.frames.reward_coin_png;

Mission.REGISTRATIONS.set(Mission.TYPE_SOFTFEAST, () => ({
    ...BaseMissionData(),
    available: cleverapps.config.availables.SOFTFEAST_MISSION,
    name: "SoftFeast",
    duration: "3 day",
    semaphore: Mission.SEMAPHORE_PRIMARY,
    competition: {
        step: [5, 5, 15, 18, 25, 30, 35, 50, 65],
        forceCoef: 0.1,
        amount: [20, 30],
        noPlayerEpisodeCoef: true,
        botAheadPlayerCoef: 0.5,
        botAheadPlayerBigDifferenceCoef: 0.2,
        bigDistanceLength: 500
    },
    logic: SoftFeast,
    prize: RewardsConfig.SoftFeast.places,
    bundle: "lives_feast",
    collectIcon: bundles.reward_icons.frames.reward_coin_png,
    sideBarJson: bundles.sidebar.jsons.soft_feast_icon_json,
    view: SoftFeastMissionWindow,
    startWindow: SoftFeastMissionWindow,
    guideWindow: {
        name: "SoftFeastGuideWindow",
        bundle: bundles.softfeastguidewindow,
        title: "SoftFeastGuideWindow.title"
    },
    finishWindow: SoftFeastMissionWindow
}));

cleverapps.InitByFeature["softfeast"] = function () {
    PixelsSwarmConfig[PixelsSwarm.COINS] = {
        amountCoef: 0.5,
        mission: Mission.TYPE_SOFTFEAST,
        pages: ["main"],
        reward: {
            resource: "coins",
            amount: [10, 20]
        }
    };
};